import React, { useEffect, useState } from "react";
import { NavBar, Footer, AnalysisPDF } from "../../components";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import configuration from "../../../package.json";

export const Intro = (props) => {
  const navigate = useNavigate();
  const { homepage } = configuration;
  const [items, setItems] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [settings, setSettings] = useState([]);
  const [filesSize, setFilesSize] = useState([]);
  const [downLoadFiles, setDownLoadFiles] = useState(null);
  
  const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
  if (path) {
    navigate.replace(path);
  }
  
  
  useEffect(() => {
    getManifest();
  }, [props]);
  
  const getManifest = () => {
    // Load manifest.json
    axios
      .get(`${homepage}data/manifest.json`)
      .then((response) => {
        const { manifest } = response.data;
        setItems(manifest.items);
        
        const uniqueObjects = [];
        for (const item of manifest.items) {
          const { content, subject } = item;
          const isDuplicate = uniqueObjects.some(
            (obj) => obj.content === content && obj.subject === subject
          );
          if (!isDuplicate) {
            uniqueObjects.push({
              content: item.content,
              subject: item.subject,
            });
          }
        }
        setSubjects(uniqueObjects);
      })
      .then(() => {
        // Load settings.json instead of settings.yaml
        axios
          .get(`${homepage}data/settings.json`)
          .then((res) => {
            // Parse JSON directly instead of using jsyaml
            const data = res.data;
            setSettings(data.filter((e) => e.lang === "en"));
          })
          .catch((error) => {
          });
      })
      .catch((error) => {
      });
  };
  
  const getFileSizeFromLink = (link, ind) => {
    let mbSize = null;
    if (!filesSize[ind]) {
      axios
        .get(link)
        .then((res) => {
          mbSize = (res.headers["content-length"] / 1024 / 1024).toFixed(2);
          setFilesSize((filesSize) => {
            const newArray = [...filesSize];
            newArray.splice(ind, 1, mbSize);
            return newArray;
          });
        })
        .catch((error) => {
        });
    }
  };
  
  return (
    <div className="flex w-full max-w-screen h-fit min-h-screen p-0 m-0 flex-col gap-2 overflow-hidden md:max-w-[875px] md:m-auto relative">
      <NavBar
        title={settings[0] ? settings[0].series_names.m : "GPS Education"}
        home={false}
        search={false}
      />
      <div className="grid w-full grid-cols-1 sm:grid-cols-2 px-2 top-16 mt-2 relative gap-4">
        {settings[0]?.stage_names &&
          Object.keys(settings[0]?.stage_names).map((key) => {
            if (items.find((e) => e.stage == key)) {
              return (
                <Link
                  key={key}
                  to={`/dict/${settings[0]?.stage_names[key]?.toLowerCase()}`}
                  className="bg-white rounded-lg text-gray-600 text-center p-1 text-md font-bold"
                >
                  {settings[0]?.stage_names[key]}
                </Link>
              );
            }
          })}
      </div>
      <div className="h-24" />
      <Footer />
    </div>
  );
};